// @ts-check
// HTML de e-mail desenhado sempre num iframe com sandbox="" e srcdoc (spec-2.0.0 RISCO-23; spec/email.md seção 19.2):
// sem scripts, formulários, navegação nem acesso à página do CRM. Vale para a prévia, as miniaturas dos cartões, o bloco
// HTML e o modo HTML no canvas. Sem allow-same-origin a altura do conteúdo não pode ser lida de fora: quem chama passa a
// altura (a estimada pelo renderizador ou uma fixa com rolagem).
import { html } from 'htm/preact';

/**
 * @param {{ html: string, title: string, height?: number, width?: number | string, scale?: number, className?: string,
 *   lazy?: boolean, scrolling?: boolean }} props
 *   scale: miniatura (o iframe tem a largura real e é reduzido por transform; a moldura ocupa o tamanho reduzido)
 */
export function SandboxedHtmlFrame({ html: source, title, height = 240, width = '100%', scale, className = '', lazy = false, scrolling = true }) {
  const frame = html`<iframe
    class="email-sandboxed-frame"
    sandbox=""
    referrerpolicy="no-referrer"
    title=${title}
    srcdoc=${source}
    loading=${lazy ? 'lazy' : undefined}
    scrolling=${scrolling ? undefined : 'no'}
    tabindex=${scale ? '-1' : undefined}
    aria-hidden=${scale ? 'true' : undefined}
    style=${{
      width: typeof width === 'number' ? `${width}px` : width,
      height: `${height}px`,
      transform: scale ? `scale(${scale})` : undefined,
      transformOrigin: scale ? 'top left' : undefined,
    }}
  ></iframe>`;
  if (!scale) return html`<div class=${`email-sandboxed-frame-box ${className}`}>${frame}</div>`;
  const frameWidth = typeof width === 'number' ? width : 680;
  return html`<div
    class=${`email-sandboxed-frame-box email-sandboxed-frame-thumbnail ${className}`}
    style=${{ width: `${Math.round(frameWidth * scale)}px`, height: `${Math.round(height * scale)}px` }}
  >${frame}</div>`;
}
